module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "The02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Secret History of Sector General")])]), _vm._v(" "), _c('p', {
    staticClass: "chapterSubtitle",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("[Note: This was Originally Written as an Introduction to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship.—")]), _vm._v(" Ed.]")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("For a series that began twenty years ago and has so far run to over a quarter of a million words, Sector General got off to a very shaky start. In fact, had the late and sadly missed Ted Carnell, who was at that time the editor of the British SF magazine, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Worlds")]), _vm._v(", not been desperate to fill a 17,000-word hole which had opened up in his November 1957 issue, the first novelette in the series, “Sector General,” would not have been accepted without literary surgery of a drastic nature.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The birth of the Sector General idea was a natural, if perhaps a premature, occurrence. I had been writing professionally for just over four years and the joins were still showing in my work. But even in those early apprenticeship days I had a strong preference for medics or extraterrestrials as the chief characters in my stories, and gradually both types began appearing in the same stories. For example, in the Ballantine collection "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Aliens Among Us")]), _vm._v(" there was a story called “To Kill or Cure,” which dealt with the fumbling attempts of a navy doctor from a rescue helicopter to give medical assistance to the survivor of a crashed extraterrestrial spaceship. So it was only natural that a story that dealt with the problems inherent in human beings treating large numbers of extraterrestrial patients in hospital conditions, and aliens treating humans, would evolve.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("The novelette “Sector General,” however, had flaws. Ted Carnell said that it lacked a coherent plot; that the principal character, Doctor Conway, simply drifted into and out of medical situations without solving his main problem—the ethical conflict in his mind ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("between the militaristic Monitor Corps, which maintained the hospital, and its intensely pacifist medical staff; and that the whole thing was so episodic that it resembled an interstellar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Emergency Ward 10")]), _vm._v(", a very corny British TV hospital series of the time. Comparing that series to my story was surely the unkindest surgical incision of all! He also said that I had spelled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("efficient")]), _vm._v(" two different ways in the story, and both ways were wrong. There were other flaws that became apparent only with hindsight, but these were corrected in the later stories of the series.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Ted did like the basic idea. He said that the background of the huge hospital in space was one that I should keep going, if only occasionally. He also said that Harry Harrison had called him at his office and was somewhat irritated with me for beating him to the punch with the interstellar hospital idea, because he had been planning a series of four or five short stories with just such a background, reckoning that it was a new idea. Harry still intended doing the stories, Ted said, but his enthusiasm had been blunted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("This last piece of news scared me half to death.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("At that time I had not met Harry Harrison, but I knew quite a lot about him. I knew since reading "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rockdiver")]), _vm._v(" as a very young fan that he had been one of my favorite authors; that he spoke rather loudly to people when he was roused; and that he was probably "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Deathworld")]), _vm._v(" on two feet. And there was I, a fan and a professional writer still wet behind the ears, having the effrontery to actually blunt "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("his")]), _vm._v(" enthusiasm! But Harry must be a truly kind and forgiving soul because nothing catastrophic has happened to me. At least not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("All the same, there must be a probability world somewhere in which he got in first with the idea and blunted my enthusiasm, and the SF shelves in the bookshops carry a series of books by Harry Harrison about an interstellar hospital. If someone would invent a transverse time-travel machine, I should dearly like to borrow it for a few hours to buy those books.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("The second story in the series was “Trouble with Emily” and Ted was much happier with this one. It featured Doctor Conway—carrying a pint-sized alien with psi powers on his shoulder instead of a large chip—and a party of Monitor Corpsmen, who were assisting him with the treatment of a brontosaurus-like patient called ")]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("Emily, because one of the Corps officers had a fondness for reading the Brontë sisters.")])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the function of the Monitor Corps, the law enforcement and executive arm of the Galactic Federation whose sixty-odd intelligent species were represented on the staff of Sector General, was something that needed clarification, I thought. The result was a very long novelette of some 21,000 words.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Essentially the Monitor Corps was a police force on an interstellar scale, but I did not want them to be the usual ruthless, routine-indoctrinated, basically stupid organization that is so handy to have around when an idealistic principal character needs a bit of ethical conflict. Conway was one of the good guys and I wanted them to be good guys too, but with different ideas as to the kind of activity that produces the greater good.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Their duties included interstellar survey and first-contact work as well as maintaining the Federation’s peace—a job that could, if they were unable to discourage the warmongers, give rise to a police action that was indistinguishable from an act of war. But the Corps much preferred to wage psychological warfare aimed at discouraging planetary and interplanetary violence and when, despite their efforts, a war broke out, then they very closely monitored the beings who were waging it.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("These warlike entities belonged to a psychological rather than physiological classification, and regardless of species they were the classification responsible for most of the trouble within the Federation. The story told of the efforts of the Monitor Corps first to attempt to prevent the war and then damp down the war, and Conway and Sector General came into it only when things went catastrophically wrong and large numbers of human and e-t casualties had to be dealt with. The original title of the story was “Classification: Warrior.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ted, however, insisted that it was much too serious a story to be tied into the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sector General")]), _vm._v(" series, and he had me delete all references to the Monitor Corps (rechristening them the Stellar Guard), the Federation, Sector General hospital and Conway. The story was retitled “Occupation: Warrior.” It appeared in the collection "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Aliens Among Us")]), _vm._v(", which also contained a proper Sector General story called “Countercharm.”")])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With the next story, “Visitor at Large,” later published in the collection entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hospital Station")]), _vm._v(", the series was firmly back on the rails. Appearing for the first time in the hospital was the insectile, incredibly fragile and emotion-sensitive Doctor Prilicla, who was later to become the most popular character in the series. The patient that Conway and Prilicla were treating was physically incapable of becoming sick, although it was, of course, subject to psychological disturbances. This particular patient was amoebic, highly adaptable and had the ability to extrude any limbs or sensory organs required for any given situation. It reproduced by fission and inherited at the time of its “birth” all of the experience and knowledge of its parent, and of its parent’s parent, and on back to the beginning of its evolution. The creature’s problem was that it had suffered a trauma that had caused it to withdraw from all outside contact and it was slowly dissolving into water; and water turned out to be the solution in both senses of the word.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next story featured a jump backwards in time to the period when the hospital was under construction, and the central character was O’Mara, who was later to become its Chief Psychologist. This was followed by a story that featured a patient with a most distressing collection of symptoms, which Conway steadfastly, and against all the advice and direct orders of his superiors, refused to treat. The stories were called “Medic” and “Outpatient” respectively, and they also appeared in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Hospital Station")]), _vm._v(" collection, which contained all five of the Sector General stories written at that time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Around this time the one-hundredth issue of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Worlds")]), _vm._v(" was coming up and Ted Carnell had been writing to his regular authors asking them to produce something special for it. I submitted a 14,000-worder called “The Apprentice”—it later appeared in my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Monsters and Medics")]), _vm._v(" collection—which he straightaway stuck into issue 99 because, he said, he had only a 7,000-word hole left in number 100. Could I fill it with a Sector General short story, within three weeks?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("I badly wanted to make it into that one-hundredth issue with its lineup of top authors, but I did not have a single alien ailment in my head. In desperation I tried to build a story around an Earthhuman condition that might have an extraterrestrial equivalent, an ailment of which I had firsthand experience, diabetes.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now there is no great problem in pushing a hypodermic needle through the tegument and subcutaneous tissue of an Earth-human and injecting a measured dose of insulin—except sometimes I go “Ouch.” But suppose the diabetic patient was a crab-like life-form, whose limbs and body were covered by a hard shell? Obviously the same procedure would not be suitable, unless one used a sterile power drill and even this, in time, would lead to grave weakening of the body structure by leaving it in the condition of an exoskeletal sieve. Solving this problem, with the help of a magnificently proportioned nurse and later an e-t pathologist called Murchison, was the plot line for the story “Countercharm,” which dropped nicely into Ted’s 7,000-word hole as well as appearing later in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Aliens Among Us")]), _vm._v(" collection.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Probably the next idea for the series came about because of a second or third re-reading of Hal Clement’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Needle")]), _vm._v(". The situation was that a Very Important Extraterrestrial Person had had a disagreement with its personal medic and as a result had been admitted to the hospital. Only much later in the story did Conway discover that the medic in question was an intelligent, organized virus life-form who lived and worked inside its patient. The story was called, inevitably, “Resident Physician” and was an introductory novelette to the first, and so far the only, Sector General novel-length work, “Field Hospital.” “Resident Physician” and “Field Hospital” were later published together as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Surgeon")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Normally I do not like stories of violence or the senseless killing that is war. But if a story is to hold the interest of the reader there must be conflict, which means violence or struggle of some kind. However, in a medical SF story of the Sector General type the violence is usually the direct or indirect result of a natural catastrophe, a disaster in space or an epidemic of some kind. And if there "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a war situation of the kind that occurred in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Surgeon")]), _vm._v(", then the medics are fighting only to save lives, and the Monitor Corps, like the good little policemen they are, are fighting to stop the war rather than win it—which is the essential difference between maintaining the peace and waging a war.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("There is not enough space to go into the plot details of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Surgeon")]), _vm._v(", but one should be mentioned. In “Occupation: Warrior,” which should have been the fourth Sector General story, “Classifi")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("cation: Warrior,” the leading character was a tactician called Dermod; and the same character turned up again as the Monitor Corps Fleet Commander who defended the hospital in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Star Surgeon")]), _vm._v(" as well as having an important part to play in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Major Operation")]), _vm._v(". I don’t know why I went to the trouble of establishing this tenuous connection between the series proper and the Sector General story that had been deliberately de-Sector Generalized, but it seemed important to me at the time.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a four-year gap before the next stories in the series were written. These were five novelettes that were planned, like the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ambulance Ship")]), _vm._v(" trio, to build progressively into a novel. They were “Invader,” “Vertigo,” “Blood Brother,” “Meatball” and “Major Operation,” and with linking material added they were published as the book-length "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Major Operation")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Invader” set the stage by introducing to the hospital a thought-controlled tool that caused havoc until Conway realized how valuable such a device could be in the hands of a surgeon who fully understood its uses. During further investigation of the planet on which the tool originated, the Monitor Corps rescued a doughnut-shaped alien who had to roll all the time to live because it did not have a heart but depended on a gravity feed system for blood circulation. This story was called “Vertigo,” and the alien was a present of my friend Bob Shaw, who called it a Drambon.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Bob thought it might be fun if I used his e-t and called it a Drambon because he had used the Drambon species in one of his stories; then we could wait and see how long it would take one of the science-fiction buffs to spot the fact that a certain extraterrestrial had cropped up, or rather rolled up, in the work of two different authors. But up until now the widely traveled Drambon life-form seems to have gone unspotted.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("The next story in the series derived from an original idea by a well-known English fan of the time, Ken Cheslin. We were at a convention party when he said, as nearly as I can remember, “James, you know how doctors used to be called leeches? Why don’t you write a story where the doctor really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" a leech?” The e-t that resulted was a life-form whose method of treatment was to withdraw practically all of its patient’s blood—a very disconcerting process for the being concerned—and remove the offending toxic material or ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("micro-organisms before returning the blood to the patient good as new. The story was called “Blood Brother.” Thanks, Ken.")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Regarding “Meatball” and the climactic “Major Operation,” there is very little to say except that the poisoned and polluted living planet that was the patient in those stories required treatment on such a vast scale that the operation was a military as well as a medical one.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The next story in the series, so far published only in Britain in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New Writings in SF 22")]), _vm._v(", was called “Spacebird.” The idea for an organic, completely non-metallic spaceship had been in my notebook for a long time, but it could not be used until I could discover a means of boosting such a bird to escape velocity. Then at one of the conventions I mentioned my problem to Jack Cohen. Jack, who is a very helpful person and a stickler for xenobiological verisimilitude, is senior lecturer in animal reproduction at the University of Birmingham in England. He knows so much about strange and alien life-forms that, when asked if a certain hypothetical extraterrestrial is physiologically possible, he invariably cites examples of a couple of terrestrial life-forms that are even weirder. The answer to my problem, Jack said, was the bombardier beetle—a small, mid-European insect that, when threatened with danger, expels and ignites gas from its rear so violently that it lands many inches away.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When the story was written, the launching of the spacecraft was from a Mesklin-type planet with high centrifugal force and low gravity at its equator to aid the process; and it was with millions of outsize bombardier beetles forming the multistaging sequences, all blasting away and hoisting the bird into space. Surely this was an idea to arouse the sense of wonder, I thought. Think of the technological achievement it represented for a race completely without metals, and think of the timing and delicacy of control involved. Try not to think of the smell…")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("The latest stories to be written are the three linked which comprise the book you are about to read. It deals with a new aspect of the work at Sector General—the hospital’s special ambulance service—and concerns the extraterrestrial medical, physiological, psychological and engineering problems that must be solved, quickly and on the site of the accident by the ambulance ship’s crew if the casualties are to survive until they reach the hospital. When these ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("problems arise, the ambulance ships are inevitably far removed from the virtually limitless facilities of Sector General, so the alien technologists and medical specialists of the crews concerned must fall back on their own ingenuity and strictly limited resources. If they make a wrong decision, the consequences can be far-reaching indeed.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To date the Sector General series has run to one short story, fifteen novelettes and one novel. I hope to go on writing about extraterrestrials, their exotic physiologies, their alien viewpoints and the problems of communication and understanding they represent. But my problem in recent years has been that, when I dream up a really alien alien, it promptly falls sick or gets itself damaged in an accident and ends up becoming a problem for Sector Twelve General Hospital.")])])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page22"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10b30d71","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312877705_The02.vue
// module id = 72
// module chunks = 0